<template>
  <div>
    <div class="course-list-fun" v-for="(data, index) in dataList" :key="index">
      <h3 v-if="showTitle">{{ data.typeName }}</h3>
      <div class="box-wrapper">
        <div
          class="box"
          v-for="(art, index) in cList"
          :key="index"
          @click="handleClickToCourseDetails(art.id)"
        >
          <img :src="art.imageUrl" alt="" />
          <div class="content">
            <div class="topic">{{ art.title }}</div>
            <div class="teacher">讲师：{{art.fullName}}</div>
            <div class="info">
              <span class="free" v-if="art.price==0">免费</span>
              <span class="price" v-if="art.price>0">价格:<em>￥</em><strong>{{ art.price }}</strong></span>
<!--              <span class="course-time">{{art.courseTime|TotalTimeFilter}}</span>-->
              <span>{{art.fullName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseList",
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    cList: Array,
  },
  computed: {
    dataList() {
      return this.cList;
    },
  },
  filters: {
    TotalTimeFilter (val) {
      let seconds = val % 60 > 10 ? val % 60 : '0' + val % 60
      // let minute =''

      let minutes = Math.floor((val - seconds) / 60 % 60) > 10 ? Math.floor((val - seconds) / 60 % 60) : '0' + Math.floor((val - seconds) / 60 % 60)

      let hours = Math.floor(val / 60 / 60) > 10 ? Math.floor(val / 60 / 60) : '0' + Math.floor(val / 60 / 60)
      return `${hours}:${minutes}:${seconds}`
    }
  },
  methods: {
    handleClickToCourseDetails(id) {
      this.$router.push({
        name: "CourseDetail",
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.course-list-fun {
  margin: 0 auto;
  width: 1280px;
  h3 {
    line-height: 50px;
    font-size: 15px;
    color: #333;
    margin: 0;
    position: relative;
    text-indent: 12px;
    &::before {
      content: "";
      position: absolute;
      left: 2px;
      top: 19px;
      width: 3px;
      height: 13px;
      background-color: #da514e;
    }
  }
  .box-wrapper {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    margin-right: -20px;
    padding: 0;
  }
  .box {
    border-radius: 10px;
    margin: 0 20px 26px 0;
    width: 305px;
    height: 290px;
    box-shadow: 0px 0px 8px 5px rgb(0 0 0 / 9%);
    cursor: pointer;
    transition: 1s;
    &:hover {
      box-shadow: 0px 2px 8px 8px rgb(0 0 0 / 20%);
      transform: scale(1.02);
    }
    img {
      border-radius: 10px 10px 0 0;
      width: 305px;
      height: 171px;
    }
    .content {
      padding: 0 12px 0 14px;
      .topic {
        line-height: 41px;
        font-size: 15px;
        color: #333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .teacher {
        line-height: 29px;
        color: #7f7f7f;
      }
      .info {
        padding: 24px 0 20px;
        line-height: 15px;
        color: #7f7f7f;
        display: flex;
        justify-content: space-between;
        .free {
          color: #3fbce9;
        }
        .price {
          color: #d9001d;
        }
        .course-time {
          background: url("~@/assets/img/course-time.png") no-repeat;
          background-size: 15px 15px;
          text-indent: 20px;
        }
      }
    }
  }
}
</style>
